import { Component } from '@angular/core';
import { environment } from '@environment/environment';
import {ActivatedRoute, Router} from '@angular/router';
import { authManager } from '@authmanager/authManager';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'app';
  count: any = 0;
  constructor(private AuthManager: authManager, private activatedRoute: ActivatedRoute, public router: Router) { }

  changeOfRoutes() {
    //debugger;
    this.count++;
    
    let r = this.router.url;
    let ac = this.activatedRoute;
    let fname = sessionStorage.getItem('firstname');
    let lname = sessionStorage.getItem('lastname');
    let uid = sessionStorage.getItem('userid');
    if (r !== '/Login' && r !== '/ForgotPassword' && r!='/Header') {
      if (fname === '' || lname === '' || fname == null || lname == null) {
        this.AuthManager.logoutUser();
      }
    }
  }
}